import WithGASetup from '../../components/WithGASetup';
import AuthContext from '../../context/AuthContext.js';
import InviteClinicianPage from './InviteClinicianPage.js';

export default WithGASetup(InviteClinicianPage, AuthContext);
